module.exports = __webpack_public_path__ + "static/img/ent-56.9ef7652.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-56.jpg
// module id = eHvt
// module chunks = 51